"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from "react";
import type { ApiDropPart } from "@/generated/models/ApiDropPart";
import WaveDropPartContentMedias from "./WaveDropPartContentMedias";
import type { ApiDropMentionedUser } from "@/generated/models/ApiDropMentionedUser";
import type { ReferencedNft } from "@/entities/IDrop";
import type { ApiWaveMin } from "@/generated/models/ApiWaveMin";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import WaveDropPartContentMarkdown from "./WaveDropPartContentMarkdown";
import { ImageScale } from "@/helpers/image.helpers";
interface WaveDropPartContentProps {
  readonly mentionedUsers: ApiDropMentionedUser[];
  readonly referencedNfts: ReferencedNft[];
  readonly wave: ApiWaveMin;
  readonly activePart: ApiDropPart;
  readonly havePreviousPart: boolean;
  readonly haveNextPart: boolean;
  readonly isStorm: boolean;
  readonly activePartIndex: number;
  readonly setActivePartIndex: (index: number) => void;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly isEditing?: boolean | undefined;
  readonly isSaving?: boolean | undefined;
  readonly onSave?: ((newContent: string) => void) | undefined;
  readonly onCancel?: (() => void) | undefined;
  readonly drop?: ApiDrop | undefined;
  readonly isCompetitionDrop?: boolean | undefined;
  readonly mediaImageScale?: ImageScale | undefined;
}
const WaveDropPartContent: React.FC<WaveDropPartContentProps> = t0 => {
  const $ = _c(37);
  const {
    mentionedUsers,
    referencedNfts,
    wave,
    activePart,
    havePreviousPart,
    haveNextPart,
    isStorm,
    activePartIndex,
    setActivePartIndex,
    onQuoteClick,
    isEditing: t1,
    isSaving: t2,
    onSave,
    onCancel,
    drop,
    isCompetitionDrop: t3,
    mediaImageScale: t4
  } = t0;
  const isEditing = t1 === undefined ? false : t1;
  const isSaving = t2 === undefined ? false : t2;
  const isCompetitionDrop = t3 === undefined ? false : t3;
  const mediaImageScale = t4 === undefined ? ImageScale.AUTOx450 : t4;
  const contentRef = React.useRef(null);
  const memoizedMentionedUsers = mentionedUsers;
  const memoizedReferencedNfts = referencedNfts;
  let t5;
  if ($[0] !== activePartIndex || $[1] !== haveNextPart || $[2] !== havePreviousPart || $[3] !== setActivePartIndex) {
    t5 = direction => {
      const isPrevious = direction === "previous";
      const isDisabled = isPrevious ? !havePreviousPart : !haveNextPart;
      const onClick = () => setActivePartIndex(activePartIndex + (isPrevious ? -1 : 1));
      return <button disabled={isDisabled} className={`${isDisabled ? "tw-text-iron-700 tw-border-iron-700 tw-cursor-default" : "tw-text-primary-400 tw-border-primary-400 hover:tw-bg-primary-400 hover:tw-text-white"} tw-bg-transparent tw-flex-shrink-0 tw-size-8 sm:tw-size-6 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-transition tw-duration-300 tw-ease-out`} onClick={e => {
        e.stopPropagation();
        onClick();
      }} aria-label={`${isPrevious ? "Previous" : "Next"} part`}><svg className="tw-size-5 sm:tw-size-4 tw-flex-shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d={isPrevious ? "M15.75 19.5 8.25 12l7.5-7.5" : "m8.25 4.5 7.5 7.5-7.5 7.5"} /></svg></button>;
    };
    $[0] = activePartIndex;
    $[1] = haveNextPart;
    $[2] = havePreviousPart;
    $[3] = setActivePartIndex;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const renderNavigationButton = t5;
  let t6;
  if ($[5] !== isStorm || $[6] !== renderNavigationButton) {
    t6 = isStorm && <div className="tw-flex tw-justify-between tw-space-x-3 md:tw-hidden tw-mb-3">{renderNavigationButton("previous")}{renderNavigationButton("next")}</div>;
    $[5] = isStorm;
    $[6] = renderNavigationButton;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== isStorm || $[9] !== renderNavigationButton) {
    t7 = isStorm && <div className="tw-hidden md:tw-block">{renderNavigationButton("previous")}</div>;
    $[8] = isStorm;
    $[9] = renderNavigationButton;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== activePart || $[12] !== drop || $[13] !== isEditing || $[14] !== isSaving || $[15] !== memoizedMentionedUsers || $[16] !== memoizedReferencedNfts || $[17] !== onCancel || $[18] !== onQuoteClick || $[19] !== onSave || $[20] !== wave) {
    t8 = <div><WaveDropPartContentMarkdown mentionedUsers={memoizedMentionedUsers} referencedNfts={memoizedReferencedNfts} part={activePart} wave={wave} onQuoteClick={onQuoteClick} isEditing={isEditing} isSaving={isSaving} onSave={onSave} onCancel={onCancel} drop={drop} /></div>;
    $[11] = activePart;
    $[12] = drop;
    $[13] = isEditing;
    $[14] = isSaving;
    $[15] = memoizedMentionedUsers;
    $[16] = memoizedReferencedNfts;
    $[17] = onCancel;
    $[18] = onQuoteClick;
    $[19] = onSave;
    $[20] = wave;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== activePart || $[23] !== isCompetitionDrop || $[24] !== mediaImageScale) {
    t9 = !!activePart.media.length && <WaveDropPartContentMedias activePart={activePart} isCompetitionDrop={isCompetitionDrop} imageScale={mediaImageScale} />;
    $[22] = activePart;
    $[23] = isCompetitionDrop;
    $[24] = mediaImageScale;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t8 || $[27] !== t9) {
    t10 = <div className="tw-h-full tw-w-full" ref={contentRef}>{t8}{t9}</div>;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== isStorm || $[30] !== renderNavigationButton) {
    t11 = isStorm && <div className="tw-hidden md:tw-block">{renderNavigationButton("next")}</div>;
    $[29] = isStorm;
    $[30] = renderNavigationButton;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== t10 || $[33] !== t11 || $[34] !== t6 || $[35] !== t7) {
    t12 = <div className="tw-w-full"><div className="tw-flex tw-flex-col md:tw-flex-row tw-w-full tw-justify-between md:tw-gap-x-3">{t6}{t7}{t10}{t11}</div></div>;
    $[32] = t10;
    $[33] = t11;
    $[34] = t6;
    $[35] = t7;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  return t12;
};
export default WaveDropPartContent;